import React from 'react';
import RDPDayPickerInput from 'react-day-picker/DayPickerInput';
import CloseIcon from '@material-ui/lab/internal/svg-icons/Close';

import * as filterStyles from '../components/FilterBox.module.scss';
import * as styles from './DayPickerInput.module.scss';
import { TextField, InputAdornment, IconButton } from '@material-ui/core';

function formatDate(date: Date): string {
  return date.toISOString().split('T')[0];
}

interface DayPickerInputProps {
  label: string;
  value: Date | undefined;
  onDayChange: (date: Date | null) => void;
  limitDate: Date | null;
  limitDirection: 'before' | 'after';
}

const TextFieldInput = React.forwardRef(({ ...restProps }: any, ref: any) => {
  return <TextField fullWidth inputRef={ref} {...restProps}></TextField>;
});
TextFieldInput.displayName = 'TextFieldInput';

const DayPickerInput = ({
  label,
  value,
  onDayChange,
  limitDate,
  limitDirection,
}: DayPickerInputProps): React.ReactElement => {
  return (
    <div className={styles.container}>
      <RDPDayPickerInput
        clickUnselectsDay
        classNames={{
          container: 'DayPickerInput' + (value ? ' ' + filterStyles.inputSelected : ''),
          overlayWrapper: 'DayPickerInput-OverlayWrapper',
          overlay: 'DayPickerInput-Overlay',
        }}
        inputProps={{
          label,
          InputProps: {
            endAdornment: value ? (
              <InputAdornment position="end">
                <IconButton
                  className={styles.clearIcon}
                  tabIndex={-1}
                  title="Clear"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onDayChange(null);
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : undefined,
          },
        }}
        component={TextFieldInput}
        placeholder="YYYY-MM-DD"
        formatDate={formatDate}
        // @ts-ignore
        dayPickerProps={
          limitDate
            ? {
                disabledDays: { [limitDirection]: limitDate },
              }
            : undefined
        }
        value={value}
        onDayChange={selectedDay => {
          if (selectedDay) {
            selectedDay.setUTCHours(0);
          }
          onDayChange(selectedDay);
        }}
      />
    </div>
  );
};

export default DayPickerInput;
